<template>
  <div class="pb-5">
    <v-simple-table class="blended-table table-layout duo-care-list-table table-fixed" id="style-2" fixed-header :height="tableHeight + 'px'">
      <template v-slot:default>
        <thead>
        <tr>
          <th style="width: 50px; text-align: center;">
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn
                  size="small"
                  rounder
                  icon
                  v-on="on"
                  @click="sortData()"
                >
                  <v-icon>mdi-sort-ascending</v-icon>
                </v-btn>
              </template>
              <span>{{filterForm.sortUpdatedAt ==='asc'? 'Từ mới đến cũ' : 'Từ cũ đến mới'}}</span>
            </v-tooltip>
          </th>
          <th style="width: 50px; left:0px" class="scroll-left">
            <input
              type="checkbox"
              class="course-extension-checkbox"
              v-model="filterForm.checkboxAll"
              @change="onChangeCheckboxAll"
            >
          </th>
          <th class="scroll-left">Mã khách hàng</th>
          <th class="scroll-left">Học viên</th>
          <th >Quản lý học tập</th>
          <th >Sale gia hạn</th>
          <th >Môn học</th>
          <th >Trạng thái</th>
          <th >Lịch sử chăm sóc</th>
        </tr>
        </thead>
        <template v-if="studentsDuo && studentsDuo.length">
          <tbody v-for="(student, indexbody) in studentsDuo" :key="'tbody'+indexbody">
          <tr v-for="(item, index) in student.routine_student_list"
              :key="`${item.id}_${index}`"
              class="bg-hover"
              @click="showQuickView(item)"
          >
            <td :rowspan="student.routine_student_list.length" v-if="index == 0" style="text-align: center; width: 50px;">{{indexbody + 1 + (filterForm.page - 1)* filterForm.limit}}</td>
            <td class="scroll-left" @click.stop=""
                :style="`background-color: ${mapCallStatusDuoCare && mapCallStatusDuoCare[item.call_status_id] ? mapCallStatusDuoCare[item.call_status_id].color : ''}`"
                style="text-align: center; left:0px; width: 50px;">
              <input type="checkbox" class="course-extension-checkbox"
                     v-model="item.checkbox"
                     @change="changeItemSelect(item)">
            </td>
            <td :rowspan="student.routine_student_list.length" v-if="index == 0" class="scroll-left" style="width:100px;padding:0">
              <div class="d-flex" style="width: fit-content">
                <div class="mx-3">
                  <div class="d-flex">
                    <div class="my-auto mr-2" style="width:20px"><v-icon v-show="item.is_new_call === 1" style="color: #FFC107; font-size: 20px">mdi-star</v-icon></div>
                    <div class="mr-2 m-auto pt-1" style="min-width:80px"> {{ item.contact_code ? item.contact_code : item.contact_id }}</div>
                    <div @click.stop="">
                      <v-tooltip right>
                        <template v-slot:activator="{ on }">
                          <v-btn
                            size="small"
                            rounder
                            icon
                            v-on="on"
                            @click="copyContactId(item)"
                          >
                            <v-icon>mdi-content-copy</v-icon>
                          </v-btn>
                        </template>
                        <span>Copy</span>
                      </v-tooltip>
                    </div>
                  </div>
                </div>
              </div>
            </td>
            <td class="scroll-left" style="left:50px; width: 245px;">
              <div class="d-flex justify-space-between">
                <div style="font-weight:500; cursor: pointer ;color:#4F4F4F" >{{ item.full_name }}</div>
                <v-menu offset-y v-if="item.phoneRelated && item.phoneRelated.length > 0">
                  <template v-slot:activator="{ on, attrs }">
                    <div
                      class="d-flex flex-column align-center"
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon
                        style="font-size: 25px"
                        color="#4caf50"
                      >
                        mdi-phone
                      </v-icon>
                    </div>
                  </template>
                  <div style="background: white; padding: 8px">
                    <div class="mobile-box main" @click="clickExecuteCall(item, item.mobile)">
                      {{formatNormalStylePhone(item.mobile)}}
                    </div>
                    <div v-for="(phone, index) in item.phoneRelated" :key="`phoneRelated` + index" class="mobile-box" @click="clickExecuteCall(item, phone)">
                      {{formatNormalStylePhone(phone)}}
                    </div>
                  </div>
                </v-menu>
                <div v-else>
                  <v-icon
                    style="font-size: 25px"
                    color="#4caf50"
                    @click.stop="clickExecuteCall(item, item.mobile)"
                  >
                    mdi-phone
                  </v-icon>
                </div>
              </div>
            </td>
            <td style="width: 200px;">
              <div v-if="item.homeroom_teacher_name">
                {{ item.homeroom_teacher_name}}
              </div>
              <img v-else src="../../../student_care/assets/empty-data.svg" alt="">
            </td>
            <td style="width: 300px;">
              <div v-if="item.user_name">
                {{ item.user_name}}
              </div>
              <img v-else src="../../../student_care/assets/empty-data.svg" alt="">
            <td style="width: 200px;">
              <v-tooltip top v-if="item.subject_name">
                <template v-slot:activator="{ on }">
                  <span v-if="item.subject_name && item.subject_name.length > subjectNameMax"  v-on="on">{{ showSubjectName(item.subject_name) }}</span>
                  <span v-else v-on="on">{{ item.subject_name ? item.subject_name : '--' }}</span>
                </template>
                <span>{{ item.subject_name }}</span>
              </v-tooltip>
              <img v-else src="../../../student_care/assets/empty-data.svg" alt="">
            </td>
            <td style="width: 200px;">
              <div
                v-if="mapCallStatusDuoCare[item.call_status_id]"
                :style="`color: ${mapCallStatusDuoCare && mapCallStatusDuoCare[item.call_status_id] ? mapCallStatusDuoCare[item.call_status_id].color : ''}`" >
                {{
                  mapCallStatusDuoCare && mapCallStatusDuoCare[item.call_status_id] ?
                    `${mapCallStatusDuoCare[item.call_status_id].callType} - ${mapCallStatusDuoCare[item.call_status_id].callStatus}` : ''
                }}
              </div>
              <img v-else src="../../../student_care/assets/empty-data.svg" alt="">

            </td>
            <td style="max-width: 425px; overflow: auto;">
              <div style="display: flex">
                <template v-if="item.routine_history_json">
                  <div
                    class="list-status-history"
                    :style="generateCss(mapCallStatusDuoCare && mapCallStatusDuoCare[status.call_status_id] ? mapCallStatusDuoCare[status.call_status_id].color : '')"
                    v-for="(status, index) in item.routine_history_json.slice(-5).reverse()"
                    :key="`${status.id}_${index}`">
                    <span class="m-auto">
                      {{
                        mapCallStatusDuoCare && mapCallStatusDuoCare[status.call_status_id] ? mapCallStatusDuoCare[status.call_status_id].callType : ''
                      }}
                    </span>
                  </div>
                </template>
                <img v-else src="../../../student_care/assets/empty-data.svg" alt="">
              </div>
            </td>
          </tr>
          </tbody>
        </template>
        <tbody key="second-tbody" v-else-if="otherData.length > 0">
        <tr v-for="(item, index) in otherData" :key="'otherdata' + index">
          <td colspan="99">
            {{item.text}}
          </td>
        </tr>
        </tbody>
        <tbody key="third-tbody" v-else>
        <tr><td colspan="9" class="text-center" style="color:red">Không có kết quả phù hợp</td></tr>
        </tbody>
      </template>
    </v-simple-table>
  </div>
</template>
<script>
import { mapGetters, mapState } from 'vuex';
import TokenService from '@/helpers/token';
import { TYPE_CURRICULUM_OBJ } from '../../../../helpers/constant';

export default {
  name: 'CourseExtensionTable',
  components: {},
  mixins: [],
  props: {
    otherData: {
      type: Array,
      default: () => [],
    },
    selectedItem: {
      type: Array,
      default: () => ([]),
    },
    filterForm: {
      type: Object,
      default: () => {
      },
    },
    studentsDuo: {
      type: Array,
      default: () => ([]),
    },
  },
  data() {
    return {
      totalSelected: 0,
      subjectNameMax: 20,
    };
  },
  watch: {
    studentsDuo: {
      deep: true,
      handler(val) {
        if (this.selectedItem.length > 0) {
          val.forEach((e) => {
            e.routine_student_list.forEach((item) => {
              if (this.selectedItem.some((el) => el.id === item.id)) {
                // eslint-disable-next-line no-param-reassign
                item.checkbox = true;
              } else {
                // eslint-disable-next-line no-param-reassign
                item.checkbox = false;
              }
            });
          });
        }
        this.filterForm.checkboxAll = val && val.length !== 0 ? this.checkAll(val) : false;
      },
    },
    totalSelected(val) {
      if (val === this.studentsDuo.length) {
        this.filterForm.checkboxAll = true;
      } else {
        this.filterForm.checkboxAll = false;
      }
    },
  },
  computed: {
    ...mapState('student_care', ['courseExtensionShowField', 'typeHeaderStatusModule', 'countStatusModuleList', 'totalContactModule']),
    ...mapState('contact_status', ['listStatus']),
    ...mapGetters('contact_status', ['mapCallStatusDuoCare']),
    ...mapGetters(['getDevice']),
    ...mapGetters('user', ['isDuoCare']),
    tableHeight() {
      const SUB_HEIGHT = 210;
      return this.getDevice.height - SUB_HEIGHT;
    },
  },
  methods: {
    showQuickView(item) {
      const routeData = this.$router.resolve({ name: 'StudentDetail', params: { id: item.id }, query: { typeCurriculum: TYPE_CURRICULUM_OBJ.DUO } });
      window.open(routeData.href, '_blank');
      this.$emit('viewedcontact', item);
    },
    clickExecuteCall(dataContact, phone) {
      const user = TokenService.getUser();
      if (user.ext) {
        const data = {
          mobile: phone,
          showCreateAppointment: false,
          contactId: dataContact.contact_id,
          callcenter_id: user.callCenterId,
          mainId: dataContact.mainId,
          mainMobile: phone,
          store: 'T',
          contactCode: dataContact.contact_code,
          homeroomTeacherId: dataContact.homeroom_teacher_id,
          studentProductId: dataContact.student_product_id,
          callStatusId: dataContact.call_status_id,
          callId: dataContact.call_id,
          module: 'duo',
        };
        Bus.$emit('voice-call-show-popup', data);
      } else {
        this.$swal({
          title: 'Lỗi!',
          text: 'Chưa có máy lẻ. Vui lòng liên hệ Admin.',
        });
      }
      this.$emit('viewedcontact', dataContact);
    },
    onChangeCheckboxAll() {
      if (this.filterForm.checkboxAll) {
        this.studentsDuo.forEach((e) => {
          e.routine_student_list.forEach((item) => {
            if (!this.selectedItem.some((el) => el.id === item.id)) {
              // eslint-disable-next-line no-param-reassign
              item.checkbox = true;
              this.$emit('change-item-selected', item, 'add');
            }
          });
        });
      } else {
        this.studentsDuo.forEach((e) => {
          e.routine_student_list.forEach((item) => {
            // eslint-disable-next-line no-param-reassign
            item.checkbox = false;
            this.$emit('change-item-selected', item, 'remove');
          });
        });
      }
      this.studentsDuo.forEach((contact) => {
        const contactTemp = contact;
        contactTemp.checkbox = this.filterForm.checkboxAll && !contact.mainId;
      });
    },
    changeItemSelect(item) {
      if (item.checkbox) {
        this.$emit('change-item-selected', item, 'add');
      } else {
        this.$emit('change-item-selected', item, 'remove');
      }
    },
    closeModalQuickView() {
      this.isOpenQuickView = false;
      this.selectedContactId = 0;
    },
    generateCss(hex) {
      if (!hex) return '';
      const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex.substring(0, 7));
      return result ? `background: rgba(${parseInt(result[1], 16)}, ${parseInt(result[2], 16)}, ${parseInt(result[3], 16)}, 0.15); border: 1px solid ${hex}; color: ${hex};width:fit-content;padding:0px 4px;display:flex` : '';
    },
    formatMobile(itemMobile) {
      return `xxxxxx${itemMobile.slice(-3)}`;
    },
    showSubjectName(name) {
      return `${name.slice(0, this.subjectNameMax)}...`;
    },
    copyContactId(item) {
      navigator.clipboard.writeText(item.contact_code ? item.contact_code : item.contact_id).then(
        () => {
          this.$swal({
            type: 'success',
            icon: 'success',
            showConfirmButton: false,
            toast: true,
            timer: 1000,
            title: 'Sao chép thành công!',
            position: 'top',
          });
        },
      );
    },
    sortData() {
      this.$emit('sortlist');
    },
    checkAll(val) {
      let check = true;
      val.forEach((e) => {
        e.routine_student_list.forEach((item) => {
          if (!item.checkbox) {
            check = false;
          }
        });
      });
      return check;
    },
  },
};

</script>

<style scoped lang="css">
/deep/ .v-data-table__wrapper > table > thead > tr >th {
  border-right: 1px solid #d2d2d2;
}
.v-data-table td {
  font-weight: 300;
  padding: 12px 8px;
}

.bg-hover:hover {
  cursor: pointer;
}
/deep/ tbody td {
  border-bottom: thin solid rgba(0, 0, 0, 0.12);
  text-align: left;
  font-size: 15px !important
}

tbody .action-cell {
  text-align: center;
}

tbody .tr-numerical-order {
  text-align: center;
}

thead th {
  height: 30px;
}

/deep/ .table-layout-checkbox .v-input--selection-controls__input {
  z-index: 1;
}

/deep/ .th_childFullName {
  min-width: 170px;
}

/deep/ .th_parentFullName {
  min-width: 170px;
}

/deep/ .th_description {
  min-width: 200px;
}

/deep/ .th_user {
  min-width: 170px;
}

/deep/ .th_email {
  min-width: 150px;
}

/deep/ .th_detailAddress {
  min-width: 250px;
}

/deep/ .th_productDescription {
  max-width: 250px;
}

/deep/ .th_numberOfCall {
  max-width: 20px;
}

/deep/ .th_appointment {
  min-width: 200px;
}

.appointment-time-wrapper {
  padding: 2px 0px;
  border: thin solid #A9A9A9;
  border-radius: 5px;
  cursor: pointer;
  min-width: 140px;
}

.custom-span-title-study-result {
  color: black;
  font-size: 13px !important;
  text-transform: none !important;
}

/deep/ .btn-show-modal-study-result span.v-btn__content {
  justify-content: normal !important;
}

.icon-comment {
  margin-left: 5px;
}

.btn-show-modal-count-interaction {
  position: absolute;
  top: 20%;
  right: 0%;
}

/deep/ .v-text-field--is-booted .v-input__control .v-input__slot {
  border: 1px solid #d9dbe9 !important;
  height: 40px !important;
  padding: 0 12px !important;
  border-radius: 4px !important;
}

/deep/ .theme--light.v-text-field > .v-input__control > .v-input__slot:before {
  border-color: #d9dbe9 !important;
}

/deep/ .v-text-field--is-booted {
  padding-top: unset !important;
  margin-top: unset !important;
}

/deep/
.theme--light.v-text-field--outlined:not(.v-input--is-focused):not(.v-input--has-state)
> .v-input__control
> .v-input__slot
fieldset {
  border: 1px !important;
}

.trail-tag {
  padding: 0px 6px;
  font-weight: 400;
  display: inline-block;
  width: 32px;
  text-align: center;
}

.tn-tag-trial {
  color: #219653;
  border: 1px solid #219653;
}

.ch-tag-trial {
  color: #F2994A;
  border: 1px solid #F2994A;
}

.v-tag-trial {
  color: #4F4F4F;
  border: 1px solid #4F4F4F;
}
.scroll-left {
  /* position: fixed; */
  position: sticky;
  background: #fff;
  border-left: 1px solid #d2d2d2!important;
}
td.scroll-left {
  z-index: 1;
}
 /deep/ .v-data-table--fixed-header > .v-data-table__wrapper > table > thead > tr > th.scroll-left {
    border-bottom: 0px !important;
    position: sticky;
    top: 0;
    z-index: 3;
}

@media screen and (max-width: 767px) {
  /deep/ .scroll-layout-left {
    position: unset !important;
  }

  /deep/ .th_mobile, .th_birthday, .th_childFullName, .th_checkbox, .th-id {
    position: sticky !important;
    left: unset !important;
  }
}

.theme--light.v-btn:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
  background-color: unset;
}

.theme--light.v-btn.v-btn--disabled.v-btn--has-bg {
  background: #94bdf6 !important;
}

.v-input--radio-group.v-input--radio-group--row .v-radio {
  margin-right: 8px !important;
}

.trail-tag {
  padding: 0px 6px;
  font-weight: 400;
  display: inline-block;
  width: 32px;
  text-align: center;
}

.tn-tag-trial {
  color: #219653;
  border: 1px solid #219653;
}

.ch-tag-trial {
  color: #f2994a;
  border: 1px solid #f2994a;
}

.v-tag-trial {
  color: #4f4f4f;
  border: 1px solid #4f4f4f;
}

.list-status-history {
  margin-right: 5px;
  border-radius: 4px;
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 13px;
  text-align: center;
  padding: 5px;
  display: flex;
  align-items: center;
}

.course-extension-checkbox {
  width: 18px;
  height: 18px;
  background: #FFFFFF;
  border: 1px solid #E0E0E0;
  border-radius: 2px;
  cursor: pointer;
  accent-color: #E91E63;
}
.duo-care-list-table table tbody tr td {
  border-right: 1px solid #d2d2d2;
  border-right-width: 1px;
  border-right-style: solid;
  border-right-color: rgb(210, 210, 210);
}
.v-data-table > .v-data-table__wrapper > table > thead > tr > th {
  font-size: 14px !important;
}
.dark-thead {
  background: rgb(28,53,69) !important;
  color: #fff !important;
}

</style>
<style lang="scss" scoped>
tbody {
  &:hover {
    td {
      background-color: #f5f5f5;
    }
  }
}
.mobile-box {
  cursor: pointer;
  border-radius: 4px;
  border: 1px solid #D3D3D3;
  color: #676767;
  padding: 5px 8px;
  transition: all .3s ease-in-out;
  &:not(:last-child) {
    margin-bottom: 8px;
  }
  &.main {
    border: 1.5px solid #6CAF60;
    color: #6CAF60;
  }
  &:hover {
    box-shadow: rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px;
  }
}
</style>
